import { colors } from '@/theme/colors';

export const Paper = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundColor: colors.surfaces.layerThree,
        padding: '24px',
        borderRadius: '8px',
      },
    },
  },
};
